import Vue from 'vue';
import config from './config';

const apiUrl = config.apiUrl;

export default {
    user: {
        authenticated: false,
        profile: null
    },
    interceptorSetup: false,
    setupAuthInterceptor(token) {
        if (!this.interceptorSetup) {
            Vue.http.interceptors.push((request, next) => {
                const currentToken = localStorage.getItem('token');
                if (currentToken) {
                    request.headers.set('Authorization', 'Bearer ' + currentToken);
                    request.headers.set('Accept', 'application/json');
                }
                next();
            });
            this.interceptorSetup = true;
        }
    },
    signIn(context, email, password, callback) {
        Vue.http.post(
            apiUrl + '/auth/sign-in', {
            email: email,
            password: password
        }
        ).then(response => {
            if (response.data) {


                if (response.data.data.role == 1 || response.data.data.role == 5) {
                    Vue.Auth.logged = true;
                    Vue.Auth.type = response.data.data.role;
                    Vue.Auth.id = response.data.data.id;
                    Vue.Auth.email = response.data.data.email;

                    this.user.authenticated = true;
                    this.user.profile = response.data.data;

                    localStorage.setItem('token', response.data.data.token);

                    // Setup interceptor once
                    this.setupAuthInterceptor(response.data.data.token);

                    context.error = false;
                    context.message = null;
                    callback(context);

                } else {
                    context.error = true;
                    context.message = "You don't have permission to login!"
                    callback(context);
                }


            }
        }).catch(response => {
            context.error = true;
            context.message = response.data.message;
            callback(context);
        })
    },
    checkApi(context, callback) {
        Vue.http.post(
            apiUrl + '/auth/checkApi'
        ).then(response => {
            if (response.data.data) {
                this.user.authenticated = true;
                this.user.profile = response.data.data;
                context.user = this.user;
                callback(context);
            } else {
                callback(false);
            }
        }).catch(response => {
            callback(false);
        })
    },
    check(context, callback) {
        let token = localStorage.getItem('token');
        if (token !== null) {
            Vue.http.post(
                apiUrl + '/auth/check?token=' + encodeURIComponent(token), {
                token: token
            }
            ).then(response => {
                if (response.data && response.data.data) { // Ensure data.data exists
                    Vue.Auth.logged = true;
                    Vue.Auth.type = response.data.data.role;
                    Vue.Auth.id = response.data.data.id;
                    Vue.Auth.email = response.data.data.email;
                    this.user.authenticated = true;
                    this.user.profile = response.data.data;
                    callback(context);
                } else {
                    // console.warn('Auth Check: Response data validation failed', response.data);
                    // alert('Auth Check: Response data validation failed');
                    callback(false);
                }
            }).catch(response => {
                let msg = response.data ? response.data.message : (response.statusText || 'Network/Server Error');
                // alert('DEBUG: Auth Check Failed.\nURL: ' + Vue.apiUrl + '/auth/check\nError: ' + msg);
                context.message = msg;
                callback(false);
            })
        } else {
            console.log('Auth Check: No token in localStorage');
            callback(false);
        }
    },
    signOut() {
        localStorage.removeItem('token');
        Vue.Auth.logged = false;
        this.user.authenticated = false;
        this.user.profile = null;

        Vue.router.push({
            name: 'login'
        })
    },
    updatePassword(context, id, password, callback) {
        Vue.http.post(
            apiUrl + '/auth/update-password', {
            id: id,
            password: password
        }
        ).then(response => {
            if (response.data) {
                console.log(response.data);
                context.message = 'success';
                callback(context);
            }
        }).catch(response => {
            context.error = true;
            context.message = response.data.message;
            callback(context);
        })
    },
};